<script>
export default {
  name: 'AccordionUiLower',
  props: {
    active: {
      default: () => false,
    },
    collapsable: {
      default: () => false,
    },
    menu: {
      default: () => false,
    },
    scroll: {
      type: Boolean,
      default: true,
    },
    id: { },
  },
  data() {
    return {
      activeStates: this.active,
      windWidth: 992,
      one: 1,
      zero: 0,
      contentHeight: 0,
    }
  },
  computed: {
    styles() {
      if (this.menu === true) {
        return this.activeStates ? 'transform: rotate(180deg)' : ''
      }
      return {
        active: this.activeStates ? this.one : this.zero,
        myHeight: this.activeStates ? this.contentHeight : this.zero,
      }
    },
  },

  mounted() {
    this.calcHeight()
    this.checkUrl()
  },
  methods: {
    resizeHandler() {
      if (!this.menu) {
        if (window.innerWidth < this.windWidth) {
          this.activeStates = false
        } else {
          this.activeStates = true
        }
      }
    },
    calcHeight() {
      const el = this.$el.getElementsByClassName('accordion-ui__bodys')[0]
      if (el) {
        this.contentHeight = el.scrollHeight
      }
    },
    toggleActive(optional) {
      if (optional === 'resizable') {
        if (window.innerWidth > this.windWidth) {
          return
        }
      }
      this.activeStates = !this.activeStates
      this.calcHeight()
    },
    checkUrl() {
      // eslint-disable-next-line no-restricted-globals
      let { hash } = location
      if (hash) {
        hash = hash.split('#')
        hash = hash[this.one]
        // eslint-disable-next-line eqeqeq
        if (hash == this.id) {
          this.activeStates = true
        }
      }
    },
  },

  // eslint-disable-next-line no-unused-vars
  render(h) {
    return this.$scopedSlots.default({
      styles: this.styles,
      activeStates: this.activeStates,
      toggleActives: this.toggleActive,
      collapses: () => {
        this.activeStates = false
      },
    })
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/app/UiElements/AccordionUiLower.vue